
import {getReplenishmentReport} from '../api/getReplenishmentReport';
import {setGetReplenishmentReportAction} from '../action';

const setGetReplenishmentReport = (params) => {
    return async (dispatch, getState) => {
        try {
            params.search = params.search.replace(/\s/g, '');
            const {data} = await getReplenishmentReport(params);

            if (data.status === 'success') {
                dispatch(setGetReplenishmentReportAction({
                    data: data.data,
                    countPage: data.countPage
                }));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetReplenishmentReport
}